module.exports = __webpack_public_path__ + "static/media/rank-04-intermediate.c7aef037.svg";